import { render } from "./OnboardingAuthenticator.vue?vue&type=template&id=11f0edd9&scoped=true&ts=true"
import script from "./OnboardingAuthenticator.vue?vue&type=script&lang=ts"
export * from "./OnboardingAuthenticator.vue?vue&type=script&lang=ts"

import "./OnboardingAuthenticator.vue?vue&type=style&index=0&id=11f0edd9&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/.pnpm/vue-loader@17.4.2_@vue+compiler-sfc@3.5.25_vue@3.5.25_typescript@5.9.3__webpack@5.103.0/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-11f0edd9"]])

export default __exports__